import DesListLibraryOverviewViewModel from 'viewmodel/DesListLibraryOverviewViewModel'
import { DesBaseCatalogAcc } from '../utils/des-base-catalog-acc';

export default class DesListLibraryOverview extends DesBaseCatalogAcc {
    constructor() {
        super(DesListLibraryOverviewViewModel);
    }

    get libraryId() {
        return this.getAttribute('libraryid') || this.getAttribute('library-id');
    }

    getProps() {
        return {
            libraryid: this.libraryId
        };
    }

    static get observedAttributes() {
        return [...DesBaseCatalogAcc.observedAttributes, 'locale', 'libraryid', 'library-id'];
    }
}

if (!window.customElements.get('des-list-library-overview')) {
    window.customElements.define('des-list-library-overview', DesListLibraryOverview);
}
